import store from "../../store";
store.dispatch('setDevice', '');
store.getters.device.isPC ? console.log("") : store.dispatch('setMobileRoute', 'mobile/');
let mPath = store.getters.mobileRoute;

export default [
  {
    path: '/refresh',
    name: 'refresh',
    component: () => import('@/views/pages/home/Refresh.vue'),
  },
];
